/**
 * RS Solutions CRM v1.0.0 - React APPLICATION
 * Copyright 2016-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'
/**
 * Reusable Loader Component
 */
export default class SpinLoader extends Component {
  render() {
    var quotes = [<h4>Pensez à consulter les élèves en coaching code. <span className="emoji-span">📚</span></h4>,
                  <h4>Vous êtes royal(e), comme toujours. <span className="emoji-span">👑</span></h4>,
                  <h4>Passez à la vitesse supérieure. <span className="emoji-span">🏎</span></h4>,
                  <h4>Pensez à mettre à jour votre calendrier. <span className="emoji-span">🗓</span></h4>,
                  <h4>N'oubliez pas de relancer les inscriptions prospects. <span className="emoji-span">✅</span></h4>,
                  <h4>Souriez, la vie est belle. <span className="emoji-span">🙂</span></h4>]
    var quote = quotes[Math.floor(Math.random()*quotes.length)];
    var displayquote = this.props.quotes? <div>{quote}<p>- L'équipe Royal Speed</p></div> : null;
    var loadmessage = this.props.loadmessage? this.props.loadmessage : "Chargement...";
    return (
      <div className="loader">
        <div>
          {displayquote}
          <div className="csstudio-loader flex-me flex-align flex-justify-center">
            <div className="csstudio-loader-spinner"></div>
            {loadmessage}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./go/views/components/signup/loader.jsx